export const countries = {
  EUR: "€",
  USD: "$",
  JPY: "¥",
  BGN: "Лв",
  CZK: "Kč",
  DKK: "Kr.",
  GBP: "£",
  HUF: "Ft",
  PLN: "zł",
  RON: "lei",
  SEK: "kr",
  CHF: "CHf",
  ISK: "kr",
  NOK: "kr",
  HRK: "kn",
  RUB: "₽",
  TRY: "₺",
  AUD: "a$",
  BRL: "R$",
  CAD: "CMXN",
  CNY: "¥",
  HKD: "HK$",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  KRW: "₩",
  MXN: "$",
  MYR: "RM",
  NZD: "$",
  PHP: "₱",
  SGD: "s$",
  THB: "฿",
  ZAR: "R",
};
